var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._v(" 请在移动端访问 ")])}
var staticRenderFns = []

export { render, staticRenderFns }